module.exports = __webpack_public_path__ + "img/setup.7e71d2de.png";